export default "__VITE_ASSET__6ec4cb4b__"